"use strict";
export class QuickSearchController {
  constructor(host) {
    this.host = host;
    this.host.addController(this);
  }
  hostConnected() {
  }
  getSearchServiceUrl(quickSearchUrl, searchTerm) {
    const params = {
      term: searchTerm,
      size: "50",
      from: "0"
    };
    const queryString = new URLSearchParams(params).toString();
    return `${quickSearchUrl}?${queryString}`;
  }
  fetchResults(quickSearchUrl, searchTerm, headers) {
    if (!searchTerm) {
      return Promise.resolve([]);
    }
    if (this.abortController instanceof AbortController && !this.abortController.signal.aborted) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();
    return fetch(this.getSearchServiceUrl(quickSearchUrl, searchTerm), {
      headers,
      signal: this.abortController.signal
    }).then(this.handleResponse).then(this.mapResponseToResults).catch(this.handleError);
  }
  handleResponse(response) {
    if (response.status === 200) {
      return response.json();
    } else {
      throw new Error("Something went wrong on the server.");
    }
  }
  mapResponseToResults(responseJson) {
    return responseJson.map((item) => {
      return {
        title: item.display_value,
        value: item.url
      };
    });
  }
  handleError(error) {
    if (error.name === "AbortError") {
      return [];
    }
    throw error;
  }
}
